import axios from './axiosConfig';
import authHeader from "./auth-header";
import { API_URL } from "utils/constants";

const getEmployeesInfo = () => {
  return axios.get(API_URL + "completeness_info/", {
    headers: authHeader(),
  });
};

export default getEmployeesInfo;
